module.exports = {
  controller: 'ShoutsController',
  template: require('./shouts.html')
}
